import $ from "jquery";
import ymaps from 'ymaps';

(() => {
    const map = {
        init: function () {
            ymaps.load().then(maps => {
                $('.js-map').each(function () {
                    const $this = $(this);
                    $this.css({'height': '480px'});
                    if (!$this.attr('id')) {
                        $this.attr('id', Math.round(new Date().getTime() + (Math.random() * 100)));
                    }
                    const center = [$this.data('lat'), $this.data('lng')],
                        map = new maps.Map($this.attr('id'), {
                            center: center,
                            controls: [],
                            zoom: 7
                        }),
                        marker = new maps.Placemark(center, {}, {
                            iconLayout: 'default#image',
                            iconImageHref: $this.data('marker'),
                            iconImageSize: [67, 68],
                            iconImageOffset: [-20, -62]
                        });
                    map.geoObjects.add(marker);
                });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/map.js